import { useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { Grid, Typography, Button, Box, Container } from '@material-ui/core'
import Auth from '../../services/auth'
import {makeStyles} from '@material-ui/core/styles'
import useAppState from '../../services/useAppState'
import WhatsAppStatusTable from '../WhatsApp/WhatsAppStatusTable'
import { WhatsAppConnect } from '../WhatsAppConnect/WhatsAppConnect'
import { WhatsAppStatus } from '../WhatsAppConnect/WhatsAppStatus'
import { WhatsAppTemplatesTable } from '../WhatsApp/WhatsAppTemplatesTable'
import { MakeWhatsAppTemplate } from '../WhatsApp/MakeWhatsAppTemplate'
import { PublishTemplateModal } from '../WhatsApp/PublishTemplateModal'
import { onBoardRetry } from '../../services/whatsApp';
import { Alert } from '@material-ui/lab'

const useStyles = makeStyles({
  root: {
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px'
  },
  selected: {
    backgroundColor: 'rgb(56, 52, 150)'
  }
})

export default function WhatsApp () {
  const {setOrganization} = useAppState()
  const history = useHistory()
  const { id } = useParams()
  const classes = useStyles()
  const {organization} = useAppState()
  const [showWhatsAppConnect, setShowWhatsAppConnect] = useState(false)
  // const [showMakeTemplate, setShowMakeTemplate] = useState(false)
  // const [editTemplate, setEditTemplate] = useState(null)
  // const [publishTemplate, setPublishTemplate] = useState(null)

  console.log('WhatsApp.organizationId', id)

  useEffect(() => {
    console.log('organization', organization)

    if (organization){
      console.log('org.whatsapp', organization.communication_methods.includes('whatsapp'))
    }

  }, [organization])

  if (id && (!organization || !organization.id)) {
    return null
  }

  // const onCloseMakeWhatsAppTemplate = (result) => {
  //   console.log('onCloseMakeWhatsAppTemplate', result)
  //   if (result) {
  //     // then refresh the table
  //   }
  //   setShowMakeTemplate(false)
  // }

  const onCloseWhatsAppConnect = () => {
    setShowWhatsAppConnect(false)
  }

  // const onEditTemplate = (template) => {
  //   console.log('onEditTemplate', template)
  //   setEditTemplate(template)
  // }

  // const onPublishTemplate = (template) => {
  //   console.log('onPublishTemplate', template)
  //   setPublishTemplate(template)
  // }

  // const onCloseEditTemplate = (result) => {
  //   console.log('onCloseEditTemplate', result)
  //   if (result) {
  //     // then refresh the table
  //   }
  //   setEditTemplate(null)
  // }

  // const onClosePublishTemplate = (res) => {
  //   console.log('onClosePublishTemplate', res)
  //   setPublishTemplate(null)
  // }

  const onSelectOrganization = (id) => {
    console.log('onSelectOrganization', id)

    return setOrganization(id)
      .then(() => {
        setTimeout(function () {
          history.replace(`/whatsapp/${id}`)
        })
      })
  }

  const stateFailed = () => {
    return Object.values(organization.settings.status).filter(s => s === 'FAIL').length > 0
  }

  const retry = () => {
      onBoardRetry({ organizationId: organization.id })
        .then(res => {
          console.log('onBoardRetry.then', res)
        })
        .catch(err => {
          console.error('onBoardRetry.catch', err)
        })
    }

  console.log('WhatsAppConfig.render.params', Auth.isRole('owner'), organization)

  console.log('WhatsAppConfig.render', !Auth.isRole('owner') && organization?.settings?.status && !organization?.settings?.status?.done)

  return (
    <div>
      <Grid spacing={2}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {/* Whatsapp Table for all organizations - show status of each organization */}
             {
                Auth.isRole('owner') && !organization ? (
                  <WhatsAppStatusTable onSelect={onSelectOrganization} organization={organization} />
                ) : null
             }

             {
              Auth.isRole('owner') && !organization?.communication_methods?.includes('whatsapp') ? (
                <Container >
                  <Typography component="h2" variant="h6" color="primary" gutterBottom style={{marginBottom: '2em'}}>
                    WhatsApp Configuration
                  </Typography>
                  <Alert variant="filled" severity="info">
                    This organization is not currently set up to use WhatsApp messaging. Organization admin must login and onboard for WhatsApp.
                  </Alert>
                </Container>
              ) : null
             }
             
             {
                !Auth.isRole('owner') && !organization?.communication_methods?.includes('whatsapp') && !organization?.settings?.status ? (
                  <Container>
                    <Typography component="h2" variant="h6" color="primary" gutterBottom style={{marginBottom: '2em'}}>
                      WhatsApp Configuration
                    </Typography>
                    <Typography variant="body1">You're not currently set up to use WhatsApp messaging. Click the Get Started button below to begin the setup process.</Typography>
                    <Typography variant="body1">In order to complete this process you will be required to login with your Meta Business account and set up a WhatsApp Business Account.</Typography>

                    <Button style={{marginTop: '2em'}} onClick={() => setShowWhatsAppConnect(true)} variant="contained" color="primary">Get Started</Button>
                  </Container>
                ) : null
             }

             {/* Whatsapp Status for given organization ID */}

              {
                !Auth.isRole('owner') &&  organization?.settings?.status && !organization?.settings?.status?.done ? (
                  <>
                    <WhatsAppStatus status={organization.settings.status} />
                    {
                      organization.settings && !organization.settings.status.done && stateFailed() ? (
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2em' }}>
                          <Button onClick={() => retry()} variant="outlined">Try Again</Button>
                        </div>
                      ) : null
                      }
                  </>
                  
                ) : null
              }

              {/*  IF ONBOARD COMPLETE THEN show table with templates */}

              {
                organization?.communication_methods?.includes('whatsapp') ? (
                  <>
                    <Typography component="h2" variant="h6" color="primary" gutterBottom>WhatsApp Configuration</Typography>
                    <Typography variant="body1" color="primary" gutterBottom>
                      Manage all your templates for WhatsApp messaging here.
                    </Typography>
                    
                    <Box mt={5}>
                      <WhatsAppTemplatesTable organizationId={organization.id} countryCode={organization.countryCode || 'CA'} />
                    </Box>
                  </>
                ) : null
              }

            { showWhatsAppConnect ? <WhatsAppConnect organizationId={organization.id} organization={organization} onClose={onCloseWhatsAppConnect} /> : null }
            {/* { showMakeTemplate ? <MakeWhatsAppTemplate open organizationId={organization.id} countryCode={organization.countryCode || 'CA'} handleClose={onCloseMakeWhatsAppTemplate} /> : null }
            { editTemplate ? <MakeWhatsAppTemplate open organizationId={organization.id} countryCode={organization.countryCode || 'CA'} handleClose={onCloseEditTemplate} template={editTemplate} /> : null }
            { publishTemplate ? <PublishTemplateModal open={publishTemplate} onClose={onClosePublishTemplate} template={publishTemplate} organizationId={organization.id} /> : null } */}
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}